module.exports = __webpack_public_path__ + "static/media/hodiny2.36dec602.jpg";